import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";

interface PropsInterface {}

interface StateInterface {}

class Default extends React.Component<PropsInterface, StateInterface> {
  public render() {
    return (
      <>
        <div className="modal modal--netw-soon">
          <div className="modal__header">
            <div className="modal__title">Присоединяйтесь!</div>
            <button
              className="modal__close"
              onClick={() => {
                Middleware.Ui.Modal.close();
              }}
            />
          </div>
          <div className="modal__body">
            <div className="modal__desc">
              Создайте страницу вашей компании и получите бесплатный доступ к
              нетворкингу «{this.props.Store.Main.Workshop.data.title}»
            </div>
            <Link
              className="btn btn--blue-white"
              to="/cabinet/profile"
              onClick={() =>
                Middleware.Ui.Modal.close("NetworkingSoon", {
                  callback: "",
                })
              }
            >
              Заполнить профиль
            </Link>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
